import React from 'react'

import { useHistory } from 'react-router-dom'

import { Modal, Table, Button, Row, Col, Divider, Form } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

const tableHeaderRows = [
  {
    label: 'FECHA',
    width: 85,
    align: 'center',
    filter: {
      type: 'date',
      name: 'fecha'
    }
  },
  { label: 'TIPO', width: 90, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serDoc'
    }
  },
  {
    label: 'NUM DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  {
    label: 'RUC',
    width: 100,
    align: 'center',
    filter: {
      type: 'text',
      name: 'ruc'
    }
  },
  {
    label: 'RAZÓN SOCIAL',
    align: 'center',
    filter: {
      type: 'text',
      name: 'razSoc'
    }
  },
  {
    label: '',
    width: 30,
    align: 'center'
  }
]

const ConsultaOtroAnioModal = ({ show, handleClose }) => {
  const [anioSeleccionado, setAnioSeleccionado] = React.useState(new Date().getFullYear())

  const history = useHistory()

  const tablaRef = React.useRef()

  const aniosOptions = React.useMemo(() => {
    const anioActual = new Date().getFullYear()
    const limiteAnios = anioActual - 10

    const output = []

    for (let i = anioActual; i >= limiteAnios; i--) {
      output.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return output
  }, [])

  const clickBuscar = React.useCallback(() => {
    tablaRef.current.reload({
      anio: anioSeleccionado
    })
  }, [anioSeleccionado])

  const clickGenerarNotaCredito = React.useCallback(
    id => {
      history.push(
        `/${CodigosTransaccionesConstant.VENTAS_NUEVA}/${id}/${TiposDeDocumentoSunatConstant.NOTA_CREDITO}/v2`
      )
    },
    [history]
  )

  return (
    <Modal size='xl' show={show}>
      <Modal.Header>
        <Modal.Title>Consulta Otro Año</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='AÑO' htmlFor='select-anio' md={4} alignRightAt='md' />
              <Col md={8}>
                <Form.Select
                  id='select-anio'
                  name='select-anio'
                  value={anioSeleccionado}
                  onChange={e => setAnioSeleccionado(e.target.value)}
                >
                  {aniosOptions}
                </Form.Select>
              </Col>
            </Form.Group>
          </Col>
          <Col md={1}>
            <Button onClick={clickBuscar}>Buscar</Button>
          </Col>
        </Row>
        <Divider />
        <Table.ServerSide
          ref={tablaRef}
          preventFirstRender
          useFilters={true}
          useNest={true}
          url='/facturaciones-historial'
          headRows={tableHeaderRows}
          baseParams={{
            tipoConsulta: 'consulta-ventas'
          }}
          rowTemplate={row => (
            <Table.Row hover key={row._id}>
              <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell align='center'>
                {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
              </Table.Cell>
              <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
              <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
              <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
              <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item
                      key='ver'
                      handleClose={handleClose}
                      onClick={e => clickGenerarNotaCredito(row._id)}
                    >
                      Generar Nota Credito
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ConsultaOtroAnioModal)
